// Descuento — paso 2 del circuito NSAUTDTO del Clipper (semillas de sucursal).
//
// Reemplaza en septiembre de 2026 al algoritmo original (que dependía de la
// fecha y no ataba el código a la sucursal). El vendedor recibe del Clipper un
// código de hasta 4 dígitos para su pedido; acá se valida que sea de la
// sucursal elegida y se genera el código final. Ver nsautdto.js.

import { paso2 } from "./nsautdto.js";

const leerCodigo = (nroSolicitud) => {
  const texto = String(nroSolicitud ?? "").trim();
  return /^\d{1,4}$/.test(texto) ? parseInt(texto, 10) : NaN;
};

export function validar({ nroSolicitud, sucursal }) {
  const codigo = leerCodigo(nroSolicitud);
  if (isNaN(codigo) || codigo < 1) {
    return "Código incorrecto. Se esperan hasta 4 dígitos";
  }
  if (!sucursal) {
    return "Elegí la sucursal";
  }
  if (paso2(Number(sucursal), codigo) === -1) {
    return "El código no corresponde a la sucursal elegida";
  }
  return null;
}

export function calcular({ nroSolicitud, sucursal }) {
  const codigo = leerCodigo(nroSolicitud);
  const final = paso2(Number(sucursal), codigo);
  if (final === -1) throw new Error("El código no corresponde a la sucursal");

  return {
    codigo: String(final).padStart(4, "0"),
    detalle: {
      codigoPedido: String(codigo).padStart(4, "0"),
      sucursalId: sucursal,
    },
  };
}
